<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.investors' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text"> {{ 'MENU.DASHBOARD.investors_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" style="margin-right: 6px !important" >{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm "
                 
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable 
        [rows]="pages"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
          [messages]="messages"

      >


            <ngx-datatable-column
  name="#"
  [width]="50"
  [sortable]="false"
>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
    {{ rowIndex + 1 }}
  </ng-template>
</ngx-datatable-column>


        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.id' | translate }}"
          prop="id"
          [width]="80"
        ></ngx-datatable-column>
      
                <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.investor_name' | translate }}"
          prop="link"
          [width]="200"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.investor_image' | translate }}"
          [width]="100"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <div class="cell-line-height text-center">
              <img [src]="row.image" alt="Ad Image" width="70" height="70" style="border-radius: 50%;"
                        (error)="onImageError($event)"
 />
            </div>
          </ng-template>
        </ngx-datatable-column>
      

                <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.nationality' | translate }}"
          prop="name"
          [width]="150"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.nationality?.name }}
          </ng-template>
        </ngx-datatable-column>

                <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.investor_phone' | translate }}"
          prop="phone"
          [width]="170"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
          {{ row.phone_without_code }}
          </ng-template>
        </ngx-datatable-column>

                <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.investor_email' | translate }}"
          prop="link"
          [width]="200"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.email }}
          </ng-template>
        </ngx-datatable-column>


        
  <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >

                       <!-- Edit Button -->
  <!-- <button
    class="dropdown-item text-primary w-100"
    ngbDropdownItem
    (click)="showTags(row.id)"
  >
    <i data-feather="eye" class="mr-50 mx-2"></i>
    {{ 'MENU.DASHBOARD.Show_Product_Tags' | translate }}
  </button> -->

  
  <button
  class="dropdown-item w-100 d-flex align-items-center justify-content-between"
  ngbDropdownItem
  (click)="viewDetails(row.id)"
>
  {{ 'MENU.DASHBOARD.investor_details' | translate }}
    <i data-feather="eye" class=" mx-2"></i>


</button>


     <!-- Edit Button -->
      <button
        class="dropdown-item w-100 d-flex align-items-center justify-content-between"
        ngbDropdownItem
        (click)="editProduct(row.id)"
      >
        {{ 'MENU.DASHBOARD.investor_edit' | translate }}
                <i data-feather="edit" class="  mx-2"></i>

      </button>

          <button
            class="dropdown-item text-danger w-100 d-flex align-items-center justify-content-between"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
             {{ 'MENU.DASHBOARD.investor_delete' | translate }}
                         <i data-feather="trash" class=" mx-2"></i>

          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>


      </ngx-datatable>
       
      </section>
    </div>
  </div>
  